module.exports = __webpack_public_path__ + "img/1.46054e86.png";